export function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-16">
      <h1 className="font-display text-4xl font-extrabold text-brand-navy tracking-tight">Privacy Policy</h1>
      <div className="mt-6 space-y-4 text-slate-700 leading-relaxed">
        <p>KenMarq Safety Training respects your privacy. We collect only the information needed to schedule, deliver, and follow up on your training — such as your name, contact information, and organization details.</p>
        <p>We never sell your data. Personal information is stored securely and used only for communications about your training, class updates you opt in to, and required record keeping for certification.</p>
        <p>You can request removal of your data at any time by contacting info@kenmarqsafety.com.</p>
      </div>
    </div>
  );
}

export function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-16">
      <h1 className="font-display text-4xl font-extrabold text-brand-navy tracking-tight">Terms & Cancellation Policy</h1>
      <div className="mt-6 space-y-4 text-slate-700 leading-relaxed">
        <h2 className="font-display font-bold text-brand-navy text-xl mt-6">Cancellations</h2>
        <p>Cancellations made 7 or more days before the class receive a full refund. Cancellations within 7 days may be applied as a credit toward a future class.</p>
        <h2 className="font-display font-bold text-brand-navy text-xl mt-6">Attendance</h2>
        <p>Participants must attend the entire class to receive certification. Please arrive 10 minutes early. Comfortable clothing is recommended — you'll be practicing on the floor with mannequins.</p>
        <h2 className="font-display font-bold text-brand-navy text-xl mt-6">Group Training</h2>
        <p>Group bookings require a 25% deposit. Full payment is due 3 business days before training. Contact us to discuss custom arrangements.</p>
      </div>
    </div>
  );
}
